<script lang="ts">
	import type { Filters, Store, User } from './home.ts'
	import type { i18n } from 'types/common'
	import type { Merge } from 'type-fest'

	import { graphql } from '$houdini'
	import { getContext, type Snippet } from 'svelte'
	import Card from '@isoftdata/svelte-card'
	import Select from '@isoftdata/svelte-select'
	import DateRange from '@isoftdata/svelte-date-range'

	const { t: translate } = getContext<i18n>('i18next')

	const setUserSetting = graphql(`
		mutation HomeSetUserSetting($input: SetUserSettingInput!) {
			setUserSetting(input: $input)
		}
	`)

	type Props = Merge<
		Filters,
		{
			stores: Array<Store>
			users: Array<User>
			first?: Snippet
			children?: Snippet
			dateRangeSetting?: string
			filterChange?: (filters: Filters) => void
		}
	>

	let {
		userId = $bindable(),
		storeId = $bindable(),
		dates = $bindable(),
		stores,
		users,
		first,
		children,
		dateRangeSetting,
		filterChange,
	}: Props = $props()

	let filters: Filters = $derived({
		userId,
		storeId,
		dates,
	})
</script>

<Card
	header={translate('common:filters', 'Filters')}
	headerClass="h5"
	bodyClass="p-2"
>
	{@render first?.()}
	<Select
		label={translate('common:user', 'User')}
		emptyText={translate('common:allUsers', 'All Users')}
		bind:value={userId}
		onchange={() => filterChange?.(filters)}
	>
		{#each users as user}
			<option value={user.id}>{user.name}</option>
		{/each}
	</Select>
	<DateRange
		bind:dates
		change={async ({ range }) => {
			filterChange?.(filters)
			if (dateRangeSetting) {
				await setUserSetting.mutate({
					input: {
						home: {
							[dateRangeSetting]: range,
						},
					},
				})
			}
		}}
	/>
	<Select
		label={translate('common:store', 'Store')}
		emptyText={translate('common:allStores', 'All Stores')}
		bind:value={storeId}
		onchange={() => filterChange?.(filters)}
	>
		{#each stores as store}
			<option value={store.id}>{store.code} - {store.name}</option>
		{/each}
	</Select>
	{@render children?.()}
</Card>
